import axios from 'axios'

const viacepApi = axios.create({
    baseURL: 'https://viacep.com.br'
})

export default viacepApi
